<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Platform Guide
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Installation Guide</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-book me-1" style="color: #00A0C1;"></i>
                  Step-by-step guide to installing and deploying the XSurfLog browser extension.
               </small>
            </div>
         </div>
      </div>

      <InstallationGuide />
   </div>
</template>

<script>
import InstallationGuide from '@/components/ExtensionConfiguration/InstallationGuide/InstallationGuide.vue';

export default {
   components: {
      InstallationGuide,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>